import { Navigate } from 'react-router-dom';

export function BillingSettingsPage() {
  return <Navigate to="/admin/settings?tab=billing" replace />;
}
